export const email = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const password = /^(?!.*[\s])(?=.*?[a-zA-Z])(?=.*?[0-9])(?=.*?[!"#$%&'()*+,./:;<=>?@[\]^_`{|}~\\-]).{8,32}$/;
export const semver = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
export const guid = /^[0-9A-F]{8}-([0-9A-F]{4}-){3}[0-9A-F]{12}$/;
// https://stackoverflow.com/a/41193739
export const url = /^(?=.{1,253}\.?$)(?:(?!-|[^.]+_)[A-Za-z0-9-_]{1,63}(?<!-)(?:\.|$)){2,}$/;
export const domain = /^(?:\w+:)?(?:\/\/)?(?:[^@\n]+@)?(?:www\.)?(?:m\.)?([^:/\n]+)/;
export const nospace = /^\S+$/;
export const otpcode = /^\d{6}$/;
export const numeric = /^\d+$/;
export const sn = /^.{3,36}$/;

export default {
  email,
  password,
  semver,
  guid,
  domain,
  url,
  nospace,
  otpcode,
  numeric,
  sn,
};
